import React from 'react';

const stripeShell =
  'w-full shrink-0 bg-[#0A0A0A] text-white flex flex-col justify-center px-6 sm:px-10 lg:px-16 py-10 lg:py-14 min-h-0';

/** Shared black footer stripe (marketing copy) for login/register — single full-width band */
export default function BrandStripe({ variant = 'default' }) {
  if (variant === 'register') {
    return (
      <div className={stripeShell}>
        <div className="max-w-7xl mx-auto w-full flex flex-col lg:flex-row lg:items-start lg:justify-between gap-10 lg:gap-16">
          <div className="space-y-5 min-w-0 flex-1">
            <h2 className="font-manrope text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-[1.1]">
              Start Your
              <br />
              AI Journey
            </h2>
            <p className="text-[#A3A3A3] text-base sm:text-lg lg:text-xl max-w-2xl leading-relaxed">
              Set up your LotMate in minutes. Connect channels. Let AI engage your customers 24/7.
            </p>
          </div>
          <div className="space-y-4 text-base sm:text-lg lg:text-xl shrink-0">
            {[
              'Unified inbox for all channels',
              'AI learns from every conversation',
              'Visual sales pipeline',
            ].map((line) => (
              <div key={line} className="flex items-center gap-4">
                <div className="w-8 h-8 rounded-full bg-[#16A34A] flex items-center justify-center shrink-0">
                  <span className="text-white text-sm font-bold">✓</span>
                </div>
                <span className="text-[#A3A3A3]">{line}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={stripeShell}>
      <div className="max-w-7xl mx-auto w-full flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 lg:gap-12">
        <div className="space-y-5 min-w-0">
          <h2 className="font-manrope text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold tracking-tight leading-[1.1]">
            AI-Powered
            <br />
            Sales Platform
          </h2>
          <p className="text-[#A3A3A3] text-base sm:text-lg lg:text-xl max-w-2xl leading-relaxed">
            Connect all your channels. Let AI handle conversations. Close more deals.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-3 text-sm sm:text-base text-[#737373] lg:pb-1">
          <span>Facebook</span>
          <span className="w-1.5 h-1.5 bg-[#525252] rounded-full shrink-0" />
          <span>WhatsApp</span>
          <span className="w-1.5 h-1.5 bg-[#525252] rounded-full shrink-0" />
          <span>SMS</span>
          <span className="w-1.5 h-1.5 bg-[#525252] rounded-full shrink-0" />
          <span>Website</span>
        </div>
      </div>
    </div>
  );
}

export const CREAM_BG = 'bg-[#fffef6]';
